import { Button, Icons } from '@commenda/kakashi';
import { TParamValue } from '@commenda/types/src/workflow/dsl';
import { getDefaultFieldRefObj } from './helpers';

export const ParamValueArrayEditor = ({
  value,
  onChange,
  renderNestedParamValueEditor,
}: {
  value: TParamValue[];
  onChange: (v: TParamValue[]) => void;
  renderNestedParamValueEditor: (
    idx: number,
    nestedValue: TParamValue,
    onChange: (idx: number, val: TParamValue) => void
  ) => React.ReactNode;
}) => {
  const addItem = () => onChange([...(value || []), getDefaultFieldRefObj()]);

  const updateAt = (idx: number, val: TParamValue) =>
    onChange(value.map((x, i) => (i === idx ? val : x)));
  const removeAt = (idx: number) => onChange(value.filter((_, i) => i !== idx));

  return (
    <div className="space-y-3">
      {value.length === 0 && (
        <p className="text-sm text-muted-foreground">
          No items yet. Add one below.
        </p>
      )}
      <div className="space-y-2">
        {value.map((item, idx) => (
          <div
            key={idx}
            className="border border-border-primary rounded-md p-2"
          >
            <div className="flex flex-row items-center justify-between">
              <div className="flex items-center gap-2">
                <Icons.List className="size-4" />
                <span className="text-sm text-muted-foreground">
                  Item {idx + 1}
                </span>
              </div>
              <Button onClick={() => removeAt(idx)}>
                <Icons.Trash01 className="size-4" />
              </Button>
            </div>
            <div className="pt-0">
              {renderNestedParamValueEditor(idx, item, updateAt)}
            </div>
          </div>
        ))}
      </div>
      <Button onClick={addItem} variant="secondary" className="w-full">
        <Icons.Plus className="size-4 mr-2" /> Add item
      </Button>
    </div>
  );
};
